import {del, get,} from '@/utils/request';

export const imageHost = 'https://zaha-img.oss-cn-beijing.aliyuncs.com/';
export const videoHost = 'https://zaha-video-raw.oss-cn-beijing.aliyuncs.com/';
export const imageCdnHost = 'https://img.jiahewushe.com/';
export const videoCdnHost = 'https://video.jiahewushe.com/';

export function requestOss({
  method,
  ossHost,
  object_key,
  authorization,
  request_date,
  fileData,
  onProgress,
}) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.responseType = 'json';

    if (onProgress) {
      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable) onProgress(e);
      };// 侦听方法
    }

    xhr.onload = () => {
      if (xhr.status > 199 && xhr.status < 300) {
        resolve();
      } else {
        reject(new Error(
          xhr.response
            ? `状态码: ${xhr.status}<br>${xhr.response.message || xhr.response.error || '未知错误'}`
            : '网络错误',
        ));
      }
    };

    xhr.open(method, ossHost + object_key, true);// 启动PUT请求
    xhr.setRequestHeader('authorization', authorization);// 设置Auth头部信息 用于验证授权
    xhr.setRequestHeader('x-oss-date', request_date);// 因为无法设置Date头部信息 所以使用x-oss设置请求时间 GMT格式
    xhr.send(fileData);// 发送文件
  });
}

export function getPutAuthorization({
  bucket_prefix,
  mime_type,
  request_date,
}) {
  return get({
    url: 'oss/put_authorizations',
    data: {
      mime_type,
      bucket_prefix,
      request_date,
    },
  });
}

// 入职申请页专用：公开页无登录态，用邀请 token 换取头像上传授权（后端仅限 administrator 目录的图片）
export function getOnboardPutAuthorization({
  token,
  mime_type,
  request_date,
}) {
  return get({
    url: 'onboard/oss/put_authorizations',
    data: {
      token,
      mime_type,
      request_date,
    },
  });
}

export function deleteFiles(object_keys) {
  if (object_keys.length === 0) return false;

  return del({
    url: 'oss',
    data: { object_keys: object_keys.join(' ').trim() },
  });
}

export function getGMTString() {
  return (new Date()).toGMTString();
}

export async function putFile({
   bucket_prefix,
   fileData,
   isVideo = false,
   onboardToken = '',
   onProgress,
}) {
  const request_date = getGMTString();
  // 携带邀请 token 时走入职页公开授权接口，否则走需登录的通用接口
  const { isError, data } = onboardToken
    ? await getOnboardPutAuthorization({ token: onboardToken, mime_type: fileData.type, request_date })
    : await getPutAuthorization({
      request_date,
      mime_type: fileData.type,
      bucket_prefix,
    });

  if (isError) return '';

  const { authorization, object_key } = data;

  try {
    await requestOss({
      method: 'PUT',
      ossHost: isVideo ? videoHost : imageHost,
      object_key,
      authorization,
      request_date,
      fileData,
      onProgress,
    });
  } catch (e) {
    return '';
  }

  return object_key;
}

export function putImage({
  bucket_prefix,
  imageData,
  onboardToken = '',
  onProgress,
}) {
  return putFile({
    bucket_prefix,
    fileData: imageData,
    onboardToken,
    onProgress,
  });
}

export function putVideo({
  bucket_prefix,
  videoData,
  onProgress,
}) {
  return putFile({
    bucket_prefix,
    fileData: videoData,
    isVideo: true,
    onProgress,
  });
}
